/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

function afterCompetionsubmit() {
	var container = jQuery( '.page-template-template-competition' );

	container.find( '.form-header' ).hide();
	container.find( '.form-content' ).hide();
	container.find( '.success-header' ).show();
	container.find( '.success-content' ).show();
	
	var featuredImage = container.find( '.page-thumbnail' );
	
	if( featuredImage.hasClass( 'featured-hidden' ) ) {
		featuredImage.remove();
		
		container.find( '.success-header' ).removeClass( 'has-thumbnail' );
	}
	
	jQuery( 'html, body' ).animate( { scrollTop: 0 }, 'slow' );

	masonry.init();
}

function frmThemeOverride_frmAfterSubmit( fin, p, errObj, obj ) {
	if( !jQuery( '.page-template-template-competition' ).length ) {
		return;
	}

	afterCompetionsubmit();
}

( function( $ ) {
	
	$( document ).ready( function() {
		var form = $( '.competition-page form' );
		var checkboxes = form.find( 'input[type=checkbox]' );
		var checkboxLabels = form.find( 'input[type=checkbox]' ).parents( 'div.frm_opt_container' ).siblings( 'label.frm_primary_label' );
		var formTextArea = form.find( 'textarea' ).parents( 'div.competition-page .with_frm_style .frm_form_field' );
		var checkBoxesMainParent = form.find( 'input[type=checkbox]' ).parents( 'div.frm_form_field.form-field.frm_required_field.frm_top_container' );

		checkboxLabels.each( function() {
			$( this ).addClass( 'label-position' );
		} );

		formTextArea.each( function() {
			$( this ).addClass( 'form-textarea' );
		} );
		
		checkBoxesMainParent.css("vertical-align", "top");

		checkboxes.click( function() {
			
			if( $( this ).is( ':checked' ) ) {
				$( this ).parent( 'label' ).addClass( "add-img-label" );
			} else {
				$( this ).parent( 'label' ).removeClass( "add-img-label" );
			}
		} );
		
		checkboxLabels.click( function() {
			var checkboxContainers = $( this ).siblings( 'div.frm_opt_container' );
			var checkbox = checkboxContainers.find( 'input[type=checkbox]' );
			
			checkbox.click();
		} );
	} );

} )( jQuery );
